import React from 'react';
import { useForm } from 'react-hook-form';

import styled from '@emotion/styled';

import { Input, Button, Box } from '@clutter/clean';

import { valid } from '@shared/config/password';

import { Banner as ErrorBanner } from '@portal/components/shared/error';

import { PasswordStrength } from './strength';

const Error = styled(ErrorBanner)`
  padding: 0 0 16px 0;
  @media (max-width: 600px) {
    padding: 8px 0;
  }
`;

type PasswordInput = {
  password: string;
};

export const PasswordForm: React.FC<{
  error?: string | null;
  loading: boolean;
  buttonText?: string;
  save(input: PasswordInput): void;
}> = ({ error, loading, buttonText = 'Update Password', save }) => {
  const { register, watch, handleSubmit } = useForm<PasswordInput>();
  const password = watch('password') ?? '';
  const disabled = !valid(password);

  const onSubmit = async (input: PasswordInput) => {
    if (disabled) return;
    await save(input);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box.Flex flexDirection="column" gap="24px">
        {error && <Error>{error}</Error>}

        <Box.Flex flexDirection="column" gap="8px">
          <Input
            required
            ref={register()}
            type="password"
            id="password"
            name="password"
            placeholder="Password"
            autoFocus
            autoComplete="new-password"
          />

          <PasswordStrength password={password} />
        </Box.Flex>

        <Button kind="primary" size="medium" loading={loading} disabled={disabled} type="submit">
          {buttonText}
        </Button>
      </Box.Flex>
    </form>
  );
};
